module.exports = __webpack_public_path__ + "img/happytablet_info4.8ccf06d8.jpg";